<app-task-completed-note
  #taskCompletedModal
  [currentTask]="app.taskPanel.selectedItem"
></app-task-completed-note>
<app-modal
  #discardChangesModal
  [modalMessage]="app.text.app.discardChanges"
  [modalTitle]="app.text.thread.modalTitle"
  (ok)="discardChanges()"
>
</app-modal>
<app-modal
  #deletePostModal
  [modalMessage]="app.text.post.deleteTaskQuestion"
  [modalTitle]="app.text.post.modalTitle"
  (ok)="deleteTask()"
>
</app-modal>

<div class="panel" *ngIf="app.taskPanel.isOpen">
  <div class="panel-header">
    <div class="row">
      <div class="col-md-12">
        <button
          class="btn btn-sm btn-close-panel pull-right"
          (click)="app.taskPanel.closePanel()"
        >
          <i class="fa-light fa-arrow-right-to-line"></i>
        </button>
      </div>
    </div>

  </div>

  <div class="panel-body">
        <div class="row">
      <div class="col-md-12">
        <div class="pull-right p-1">
          <button
            *ngIf="this.app.post.hasEditPermission(app.taskPanel.selectedItem)"
            class="btn btn-sm btn-clean"
            (click)="deletePostModal.open()"
            [title]="app.text.post.delete"
          >
            <i class="fa fa-trash"></i>&nbsp;
            <span>{{app.text.app.delete}}</span>
          </button>
        </div>
      </div>
    </div>
    <!-- Status of the task -->
    <div class="col-md-12 statusOption">
      <span> --- </span>
      <div class="panel-status badge-color col-md-10 text-center m-1">
      {{ threadStatus }} 
      </div>
      <span> --- </span>

    </div>

    <!-- Details of the task -->
    <div class="col-md-12 task-description">
      <div class="description">
        {{ app.field.getLabel(app.fieldId.post.taskDescription) }}
      </div>
      <textarea
        [(ngModel)]="app.taskPanel.selectedItem.taskDescription"
        [disabled]="!app.taskPanel.hasEditPermissionForDescription"
      >
      </textarea>
      <span
        class="invalidspan"
        *ngIf="app.taskPanel.selectedItem.taskDescription === ''"
      >
        <i class="fal fa-exclamation-circle"></i>
      </span>
    </div>
    <div
      *ngFor="let postField of columns"
      [ngClass]="{
        'taskNote-field-container': postField === app.fieldId.post.taskNote
      }"
    >
      <div class="row">
        <app-field
          *ngIf="postField !== app.fieldId.post.taskNote && postField !== ''"
          [model]="app.taskPanel.selectedItemModel"
          [field]="postField"
          [showLabel]="true"
          [noStriped]="true"
          [panelInput]="true"
          [disabled]="!this.app.post.hasEditPermission(app.taskPanel.selectedItem)"
        ></app-field>
        <app-field
          *ngIf="
            postField === app.fieldId.post.taskNote &&
            app.taskPanel.selectedItem.taskCompleted
          "
          [model]="app.taskPanel.selectedItemModel"
          [field]="postField"
          [showLabel]="true"
          [noStriped]="true"
          [panelInput]="true"
          [disabled]="!app.permission.post.hasEditPermissionForTaskNote"
        ></app-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="pull-right m-2">
          <app-attachments-controls
            *ngIf="hasPermissionToAddAttachment()"
            [id]="app.taskPanel.selectedItem._id"
            type="post"
          >
          </app-attachments-controls>
        </div>
      </div>
    </div>
    <div class="attachments-container pt-2">
      <app-attachments
        *ngIf="app.unlockedId === null"
        [id]="app.taskPanel.selectedItem._id"
        type="post"
        [editPermission]="app.post.hasEditPermission(app.taskPanel.selectedItem)"
        [files]="app.taskPanel.selectedItem._attachments"
        [filesDetails]="app.taskPanel.selectedItem.attachmentHistory"
      >
      </app-attachments>
    </div>

    <div class="row">
      <div class="row centeredRow mt-5">
        <div
          class="col-md-6 text-center saveBtn"
          *ngIf="!app.taskPanel.selectedItem.taskCompleted"
          (click)="taskCompletedModal.openModal()"
          [ngClass]="{'disabled': !hasPermissionToClose()}"
          
        >
          <button class="saveBtn">
            {{ app.text.post.markCompleted }}
          </button>
        </div>
        <div
          class="col-md-6 text-center completedBtn"
          *ngIf="app.taskPanel.selectedItem.taskCompleted"
          (click)="
            app.taskCompleted.changeTaskCompletion(
              app.customer,
              app.taskPanel.selectedItem
            )
          "
         [ngClass]="{'disabled': !showReopenButton()}"
        >
          <button class="completedBtn">
            {{ app.text.post.completed }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="panel-footer">
    <div>
          <div
      *ngIf="
        app.taskPanel.selectedItem.taskCompleted &&
        app.taskPanel.selectedItem.completedBy
      "
      class="complete-task"
    >
    <span class="m-1 completedBy">

      <app-user-link
        [name]="app.taskPanel.selectedItem.completedBy"
        [type]="'post'"
      ></app-user-link>
    </span>
    <span class="font-size-12">
      completed this task on
      {{ app.taskPanel.selectedItem.completedAt | date : "yyyy-MM-dd": "UTC" }}
    </span>
    </div>
      <div>
        <app-credits class="credits" type="post" [isCreated]="true">
        </app-credits>
      </div>
      <div>
        <app-credits
          [ngClass]="{
            credits:
              app.taskPanel.selectedItem.create_time !==
              app.taskPanel.selectedItem.update_time
          }"
          type="post"
          [isEdited]="true"
        ></app-credits>
      </div>
    </div>
  </div>
</div>
